
import { Component, Vue } from 'vue-property-decorator'
import { AppModule, DeviceType } from '@/store/modules/app'
import { TicketsModule } from '@/store/modules/tickets'
import editTeacher from '@/views/newOrderIT/teacher.vue'
import editTutor from '@/views/newOrderIT/tutor.vue'
import editTutorLive from '@/views/newOrderLive/tutor.vue'
import editTutorNetWork from '@/views/newOrderNetwork/tutor.vue'
import editTutorAdministration from '@/views/newOrderAdministration/tutor.vue'
import editTutorFwbz from '@/views/newOrderFuWuBaoZhang/tutor.vue'
import editTutorCggl from '@/views/newOrderCaiGouGuanLi/tutor.vue'

@Component({
  name: 'editDialog',
  components: {
    editTeacher,
    editTutor,
    editTutorLive,
    editTutorNetWork,
    editTutorAdministration,
    editTutorFwbz,
    editTutorCggl
  }
})
export default class extends Vue {
  get device() {
    return AppModule.device
  }

  get classObj() {
    return {
      mobile: this.device === DeviceType.Mobile
    }
  }

  get dialogVisible() {
    return TicketsModule.editDialog
  }

  get currentTicket() {
    console.log(TicketsModule.currentTicket)

    return TicketsModule.currentTicket || {}
  }

  // 正在操作的工单index
  get ticketIndex() {
    return TicketsModule.currentTicketIndex || 0
  }

  // 关闭弹框
  private handleClose() {
    TicketsModule.ToggleDialogStatus({
      name: 'editDialog',
      value: false
    })
  }

  private handleSuccess(res: any) {
    this.$emit('handleSuccess', res)
  }
}
